module.exports = "/_next/static/images/ScoreMeter2@2x-722457e8366bf00855b59b1b2e2af7f2.png";